import { AfterContentInit, Directive, ElementRef, Input, AfterViewInit, OnChanges, AfterContentChecked } from '@angular/core';

@Directive({
    selector: '[autofocus]'
})
export class AutofocusDirective implements AfterContentInit {
    //AfterContentInit, AfterViewInit, OnChanges, AfterContentChecked {
  /*  ngAfterContentChecked(): void {
        setTimeout(() => {

            this.el.nativeElement.focus();

        }, 500);
    }
    ngOnChanges(changes: import("@angular/core").SimpleChanges): void {
        setTimeout(() => {

            this.el.nativeElement.focus();

        }, 500);
    }

    ngAfterViewInit(): void {
        setTimeout(() => {

            this.el.nativeElement.focus();

        }, 500);
    }*/
    ngAfterContentInit(): void {
        setTimeout(() => {

            this.el.nativeElement.focus();

        }, 500);
    }
    @Input() public appAutoFocus: boolean;

    public constructor(private el: ElementRef) {

    }

}